<template>
    <div v-if="!accepted">
        <transition name="modal">
            <div class="modal-mask">
                <div class="modal-wrapper">
                    <div class="modal-container">

                        <div class="modal-body text-center">
                            <h3>Welcome to</h3>
                            <img class="logo" title="Pimblr" src="../../assets/PimblrLogoLarge.png"/>
                            <hr>
                            <p>
                                To view this content and become<br>part of our community you need to be at least<br>
                                <strong>18 years old</strong>
                            </p>
                            <hr>
                            <p>
                                <a href="http://www.google.com" class="btn btn-outline-primary">I'm not yet 18</a>
                                <button @click.prevent="accept" class="btn btn-outline-primary">I'm 18 or older</button>
                            </p>
                        </div>

                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
    import logo from '../layout/CenterLogo';


    export default {
        name: "ageBlock",
        props: ['acceptAction'],
        data(){
            return {
                accepted: false
            }
        },
        created(){
            if(this.$store.state.user.isLoggedIn){
                this.accepted = true;
            }
            this.$nextTick(()=>{
                if(this.$store.state.user.isLoggedIn){
                    this.accept();
                }
            })

        },
        methods:{
            accept(){
                this.accepted = true;
                if(this.acceptAction)this.acceptAction();
            }
        },
        components:{
            logo
        }
    }
</script>

<style scoped lang="sass">

    @import '../../assets/sass/vars.scss'

    .modal-mask
        position: fixed
        z-index: $z-ageBlocker
        top: 0
        left: 0
        width: 100%
        height: 100%
        background-color: rgba(0, 0, 0, .98)
        display: table
        transition: opacity .3s ease

    .modal-wrapper
        display: table-cell
        vertical-align: middle


    .modal-container
        max-width: 600px
        margin: 0px auto
        padding: 20px 30px
        background-color: #fff
        border-radius: 2px
        box-shadow: 0 2px 8px rgba(0, 0, 0, .33)
        transition: all .3s ease
        font-family: Helvetica, Arial, sans-serif

    .modal-header h3
        margin-top: 0


    .logo
        max-width: 200px


    .modal-body
        margin: 20px 0


    .modal-default-button
        float: right

    .modal-enter
        opacity: 0


    .modal-leave-active
        opacity: 0

    .modal-enter .modal-container,
    .modal-leave-active .modal-container
        -webkit-transform: scale(1.1)
        transform: scale(1.1)



</style>



// WEBPACK FOOTER //
// src/components/layout/AgeBlock.vue